import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import { StreamI18nProvider } from './StreamI18nContext.js';
const StreamVideoContext = createContext(undefined);
/**
 * StreamVideo is a provider component which should be used to wrap the entire application.
 * It provides the client object to all children components and initializes the i18n instance.
 */
const StreamVideoProvider = ({
  children,
  client,
  i18nInstance,
  language,
  translationsOverrides
}) => {
  return jsx(StreamVideoContext.Provider, {
    value: client,
    children: jsx(StreamI18nProvider, {
      i18nInstance: i18nInstance,
      language: language,
      translationsOverrides: translationsOverrides,
      children: children
    })
  });
};
/**
 * Hook to access the nearest StreamVideo client instance.
 */
const useStreamVideoClient = () => {
  return useContext(StreamVideoContext);
};
export { StreamVideoProvider, useStreamVideoClient };